import { useTranslation } from "react-i18next";
import "./pagination.scss";

const AdminPagination = ({
  totalPages,
  currentPage,
  limit,
  onPageChange,
  onLimitChange,
}) => {
  // Build page list: 1 … (current-1,current,current+1) … last
  const getPageNumbers = () => {
    if (!totalPages || totalPages < 1) return [];

    const pages = [];
    pages.push(1);

    let start = Math.max(2, currentPage - 1);
    let end = Math.min(totalPages - 1, currentPage + 1);

    // Near Start
    if (currentPage <= 3) {
      end = Math.min(4, totalPages - 1);
    }
    // Near End
    if (currentPage >= totalPages - 2) {
      start = Math.max(totalPages - 3, 2);
    }

    if (start > 2) pages.push("...");

    for (let i = start; i <= end; i++) pages.push(i);

    if (end < totalPages - 1) pages.push("...");

    if (totalPages > 1) pages.push(totalPages);

    return pages;
  };

  const { t } = useTranslation();

  const pageNumbers = getPageNumbers();

  return (
    <div className="d-flex align-items-center justify-content-end">
      <nav className="d-flex justify-content-center my-4">
        <ul className="pagination pretty mb-0">
          {/* Left Arrow */}
          <li
            className={`page-item arrow ${currentPage === 1 ? "disabled" : ""}`}
            onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
          >
            <span className="page-link cursor-pointer" aria-label="Previous">
              &laquo;
            </span>
          </li>

          {/* Page numbers with ellipses */}
          {pageNumbers.map((p, idx) => {
            const isEllipsis = p === "...";
            const isActive = p === currentPage;

            return (
              <li
                key={`${p}-${idx}`}
                className={`page-item ${isActive ? "active" : ""} ${
                  isEllipsis ? "disabled" : ""
                }`}
                onClick={() => {
                  if (!isEllipsis && p !== currentPage) onPageChange(p);
                }}
              >
                <span
                  className={`page-link ${
                    isEllipsis ? "cursor-default" : "cursor-pointer"
                  }`}
                  style={{ cursor: isEllipsis ? "default" : "pointer" }}
                >
                  {p}
                </span>
              </li>
            );
          })}

          {/* Right Arrow */}
          <li
            className={`page-item arrow ${
              currentPage === totalPages ? "disabled" : ""
            }`}
            onClick={() =>
              currentPage < totalPages && onPageChange(currentPage + 1)
            }
          >
            <span className="page-link cursor-pointer" aria-label="Next">
              &raquo;
            </span>
          </li>
        </ul>
      </nav>

      <select
        className="form-select ms-3"
        value={limit}
        onChange={(e) => onLimitChange(parseInt(e.target.value))}
        style={{ width: "auto" }}
      >
        {[10, 20, 50, 100].map((val) => (
          <option key={val} value={val}>
            {val} {t("per-page")}
          </option>
        ))}
      </select>
    </div>
  );
};

export default AdminPagination;
